import { Chip, TextField, useTheme } from "@mui/material";

export default function MUITags(props) {
  const {
    label,

    value,
    name,

    valueArray,
    nameArray,

    setFieldValue,
    handleBlur,
    handleChange,
    ...rest
  } = props;

  const theme = useTheme();

  const handleTagChange = (e, next) => {
    var tags = [];
    var addCommaBack =
      e.target.value.length > 0 &&
      e.target.value.charAt(e.target.value.length - 1) === ",";
    var tagArray = e.target.value.split(",");
    var tagList = "";
    tagArray.forEach((tag) => {
      if (tag !== "") {
        tags.push(tag.trim().toLowerCase().split(" ").join("-"));
        if (tagList !== "") {
          tagList += ",";
        }
        tagList += tag;
      }
    });
    if (addCommaBack) {
      tagList += ",";
    }
    e.target.value = tagList;

    next(e);
    setFieldValue(nameArray, tags);
  };

  function handleDeleteTag(tag, tags) {
    var newTags = [];
    var tagList = "";
    tags.forEach((tagKey) => {
      if (tagKey !== tag) {
        newTags.push(tagKey);
        if (tagList !== "") {
          tagList += ",";
        }
        tagList += tagKey;
      }
    });
    setFieldValue(name, tagList);
    setFieldValue(nameArray, newTags);
  }

  return (
    <>
      <TextField
        name={name}
        label={label}
        value={value}
        variant="outlined"
        fullWidth
        margin="normal"
        inputProps={{ style: { textTransform: "lowercase" } }}
        onBlur={async (e) => {
          handleTagChange(e, handleBlur);
        }}
        onChange={(e) => {
          handleTagChange(e, handleChange);
        }}
        {...rest}
      />
      {valueArray.map((tag, index) => {
        return (
          <Chip
            key={index}
            label={tag}
            onDelete={(e) => {
              handleDeleteTag(tag, valueArray);
            }}
            color={theme?.palette?.mode === "dark" ? "secondary" : "primary"}
            variant="outlined"
          />
        );
      })}
    </>
  );
}
